import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ISimPublicationOverview } from '../../shared/models/document-publication-overview';
import { SanitizeService } from '../../../../shared/services/sanitizeService';
@Component({
    selector: 'app-document-details-overview',
    templateUrl: './document-details-overview.component.html',
    styleUrl: './document-details-overview.component.scss',
    standalone: false
})
export class DocumentDetailsOverviewComponent implements OnChanges {
  @Input() SIMPublicationOverview: ISimPublicationOverview | null = null;
  loading: boolean = true;
  sanitizedSynopsis: string = '';


  constructor(private sanitizeService: SanitizeService) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['SIMPublicationOverview']) {
      if(this.SIMPublicationOverview?.synopsis){
        this.sanitizedSynopsis = this.sanitizeService.sanitize(this.SIMPublicationOverview?.synopsis);
      }
      this.loading = false;
    }
  }
}
